import styled from 'styled-components';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

export const Item = styled(DropdownMenu.Item)`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 12px;
	border-radius: 6px;
	outline: none;
	user-select: none;
	font-size: 13px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};

	&[data-highlighted] {
		background: ${({ theme }) => theme.gray[200]};
	}
`;

export const Dot = styled.div`
	margin-left: auto;
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background-color: ${({ theme }) => theme.blue[600]};
`;
